import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const SocialAuthCallback: React.FC = () => {
  const [status, setStatus] = useState('Signing you in...');
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const returnTo = params.get('returnTo') || '/';

    if (!token) {
      setStatus('Missing token. Please try again.');
      return;
    }

    api
      .post('/auth/social-session', { token })
      .then(response => {
        const sessionUser = response.data.user;
        if (sessionUser) {
          setSession(sessionUser);
          navigate(sessionUser?.isAdmin ? '/admin' : returnTo);
        } else {
          setStatus('Unable to sign in. Please try again.');
        }
      })
      .catch(() => {
        setStatus('Unable to sign in. Please try again.');
      });
  }, [location.search, navigate, setSession]);

  return (
    <div className="container">
      <div className="loading">{status}</div>
    </div>
  );
};

export default SocialAuthCallback;
